import api from '@/api';

const contractWorkOffer = {
  namespaced: true,

  state() {
    return {
      isLoading: true,
      taxationTypeOptions: [],
    };
  },

  mutations: {
    setTaxationType(state, payload) {
      const data = payload.contractorParameters || {};
      if (data.taxationType) {
        state.taxationTypeOptions = data.taxationType.map((item) => ({
          label: item.name,
          value: item.id,
        }));
      }
    },
    changeLoading(state, status) {
      state.isLoading = status;
    },
  },

  actions: {
    async getContractorOptions({ commit, rootState }) {
      try {
        commit('changeLoading', true);
        const { isLoggedIn } = rootState.user;

        if (!isLoggedIn) {
          return;
        }

        const contractorParameters = await api.contractWorks.contractor.contractorParameters();
        commit('setTaxationType', { contractorParameters });
      } catch (e) {
        console.error(e);
        commit('setTaxationType', {});
      } finally {
        commit('changeLoading', false);
      }
    },
  },

};

export default contractWorkOffer;
